(function () {

  var base       = window.CartAgendaConfig?.middlewareBaseUrl || window.middlewareBaseUrl || '';
  var btnEdit    = document.getElementById('btn-edit');
  var btnCancel  = document.getElementById('btn-cancel');
  var btnSave    = document.getElementById('btn-save');
  var viewEl     = document.getElementById('vlc-view');
  var editEl     = document.getElementById('vlc-edit');
  var loadingEl  = document.getElementById('vlc-loading');
  var responseEl = document.getElementById('vlc-response');
  var form       = document.getElementById('formUpdateCustomer');

  /* ── Modo del formulario: 'edit' | 'create' ── */
  var _editMode = 'edit';

  function loading(state) { loadingEl.style.display = state === 'show' ? 'flex' : 'none'; }

  /* Crear o editar paciente con tiempo límite: si el middleware se cuelga, el
     cargando se oculta y el catch muestra el error en lugar de girar sin fin. */
  var WS_TIMEOUT_MS = 20000;
  function fetchConTiempo(url, opts) {
    var ctrl  = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, WS_TIMEOUT_MS);
    return fetch(url, Object.assign({}, opts, { signal: ctrl.signal }))
      .finally(function () { clearTimeout(timer); });
  }
  function setVal(id, v)  { var el = document.getElementById(id); if (el) el.value = v; }
  function getVal(id)     { var el = document.getElementById(id); return el ? el.value : ''; }

  function showMsg(msg, ok) {
    responseEl.textContent       = msg;
    responseEl.style.display     = 'block';
    responseEl.style.color       = ok ? '#059669' : '#e31c79';
    responseEl.style.borderColor = ok ? '#a7f3d0' : '#fce4f3';
    responseEl.style.background  = ok ? '#f0fdf4' : '#fff0f6';
    setTimeout(function () { responseEl.style.display = 'none'; }, 4000);
  }

  function norm(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
  }

  /* ════════════════════════════════════
     SYNC PACIENTE → CARRITO + cart-data-pay
  ════════════════════════════════════ */
  function syncPaciente(pac) {
    if (!pac) return;
    if (typeof window.__vtlSyncPaciente === 'function') {
      window.__vtlSyncPaciente(pac);
    } else {
      setTimeout(function () {
        if (typeof window.__vtlSyncPaciente === 'function') {
          window.__vtlSyncPaciente(pac);
        }
      }, 200);
    }
  }

  /* ════════════════════════════════════
     NORMALIZAR PACIENTES
  ════════════════════════════════════ */
  (function normalizePacientes() {
    var raw = window._vlcPacientes;
    if (!raw) { window._vlcPacientes = []; return; }

    if (!Array.isArray(raw) && Array.isArray(raw.pacientes)) {
      window._vlcPacientes = raw.pacientes;
      return;
    }

    if (!Array.isArray(raw) && (raw['0'] || raw[0])) {
      var titular     = raw['0'] || raw[0];
      var secundarios = Array.isArray(raw.pacientes) ? raw.pacientes : [];
      var arr = [titular];
      secundarios.forEach(function (s) { arr.push(s); });
      window._vlcPacientes = arr;
      return;
    }

    if (Array.isArray(raw)) return;

    window._vlcPacientes = [];
  })();

  var _pacientes      = window._vlcPacientes  || [];
  var _customer       = window._vlcCustomer   || {};
  var _activePaciente = _pacientes[0]         || null;
  var _activeIndex    = 0;

  function getInitials(n, a) {
    return ((n || '').trim().charAt(0).toUpperCase() + (a || '').trim().charAt(0).toUpperCase()) || '?';
  }

  function pNombre(p)   { return (p.primerNombre   || p.nombres   || '').trim(); }
  function pApellido(p) { return (p.primerApellido || p.apellidos || '').trim(); }

  /* ════════════════════════════════════
     VALIDACIÓN DE EXISTENCIA DE DOCUMENTO — Formulario edición/creación
     Consume: ajax/checkPatientDocument.php
     Aplica feedback en: #e-tipodoc y #e-documento
     Flag interno: _editDocExiste (bloquea el guardado)
  ════════════════════════════════════ */
  var _editDocTimer  = null;
  var _editDocExiste = false;

  /**
   * Muestra u oculta el feedback de "documento existente" en el formulario de edición.
   * @param {boolean} visible
   */
  function _setEditDocExistsFeedback(visible) {
    var feedbackTipo = document.getElementById('doc-exists-tipodoc-edit');
    var feedbackDoc  = document.getElementById('doc-exists-doc-edit');
    var inputTipo    = document.getElementById('e-tipodoc');
    var inputDoc     = document.getElementById('e-documento');

    if (feedbackTipo) feedbackTipo.classList.toggle('is-visible', visible);
    if (feedbackDoc)  feedbackDoc.classList.toggle('is-visible', visible);

    if (inputTipo) {
        inputTipo.classList.toggle('doc-exists-error', visible);
        inputTipo.classList.toggle('is-invalid', visible);
        if (visible) inputTipo.classList.remove('is-valid');
        // NO setCustomValidity en el select — solo la clase controla el borde
    }
    if (inputDoc) {
        inputDoc.classList.toggle('doc-exists-error', visible);
        inputDoc.classList.toggle('is-invalid', visible);
        if (visible) inputDoc.classList.remove('is-valid');
        // setCustomValidity solo cuando visible, limpiar cuando no
        inputDoc.setCustomValidity(visible ? 'Documento existente.' : '');
    }
}

  /**
   * Llama al endpoint PHP y actualiza flag + UI.
   * En modo edición pasa el id del paciente activo para excluirlo de la búsqueda.
   */
  async function _checkEditDocumento() {
    var docInput  = document.getElementById('e-documento');
    var tipoDocEl = document.getElementById('e-tipodoc');
    if (!docInput || !tipoDocEl || !base) return;

    var doc    = (docInput.value  || '').trim();
    var tipoId = (tipoDocEl.value || '').trim();

    if (doc.length < 3 || !tipoId || tipoId === '0' || tipoId === '') {
      _setEditDocExistsFeedback(false);
      _editDocExiste = false;
      return;
    }

    /* En modo edición excluir al paciente activo para que su propio doc no dispare el error */
    var idPaciente = (_editMode === 'edit' && _activePaciente && _activePaciente.id)
      ? _activePaciente.id
      : 0;

    try {
      var url = base + 'ws/checkPatientDocument.php'
              + '?documento='       + encodeURIComponent(doc)
              + '&idTipoDocumento=' + encodeURIComponent(tipoId)
              + '&idPaciente='      + encodeURIComponent(idPaciente);

      var res  = await fetch(url);
      var data = await res.json();

      _editDocExiste = (data.existe === true);
      _setEditDocExistsFeedback(_editDocExiste);

    } catch (e) {
      /* Si el servicio falla, no bloqueamos */
      _editDocExiste = false;
      _setEditDocExistsFeedback(false);
    }
  }

  /* ── Listener tipo doc edición ── */
  function _bindTipoDocListener() {
    var tipoDocEl = document.getElementById('e-tipodoc');
    if (tipoDocEl && !tipoDocEl.dataset.docExistsDone) {
      tipoDocEl.dataset.docExistsDone = '1';
      tipoDocEl.addEventListener('change', function () {
        clearTimeout(_editDocTimer);
        _editDocTimer = setTimeout(_checkEditDocumento, 300);
      });
    }
  }

  /* ════════════════════════════════════
     PACIENTE ESCOGIDO (V15-M3)
     Al recargar se perdía el paciente escogido: al iniciar se sincronizaba siempre el
     primero, que además reescribía las líneas del carrito. Ahora el escogido queda en las
     líneas (_paciente_id, que escribe cart-data-pay al sincronizarlo) y, por si la recarga
     llega antes de que terminen de escribirse, también en sessionStorage.
  ════════════════════════════════════ */
  var CLAVE_PACIENTE = 'vlc_paciente_id';

  function recordarPaciente(p) {
    if (!p || p.id == null || String(p.id) === '') return;
    try { sessionStorage.setItem(CLAVE_PACIENTE, String(p.id)); } catch (e) {}
  }

  function pacienteRecordado() {
    try { return sessionStorage.getItem(CLAVE_PACIENTE); } catch (e) { return null; }
  }

  function indicePorId(id) {
    if (id == null || String(id) === '') return -1;
    for (var i = 0; i < _pacientes.length; i++) {
      if (_pacientes[i] && _pacientes[i].id != null && String(_pacientes[i].id) === String(id)) return i;
    }
    return -1;
  }

  /* Exámenes del carrito: el cargo de domicilio no lleva paciente */
  function lineasDeExamen(cart) {
    return ((cart && cart.items) || []).filter(function (item) {
      return !(typeof window.vtlEsCargo === 'function' && window.vtlEsCargo(item));
    });
  }

  /* El _paciente_id de las líneas, si todas dicen el mismo; null si no lo tienen o difieren */
  function idEnLineas(cart) {
    var ids = {};
    lineasDeExamen(cart).forEach(function (item) {
      ids[String((item.properties || {})._paciente_id || '').trim()] = true;
    });
    var lista = Object.keys(ids);
    return lista.length === 1 && lista[0] !== '' ? lista[0] : null;
  }

  /* Las líneas ya tienen los datos que escribiría cart-data-pay (actualizarPropertiesItems) */
  function lineasAlDia(cart, p) {
    var nombre = (pNombre(p) + ' ' + pApellido(p)).trim();
    return lineasDeExamen(cart).every(function (item) {
      var pr = item.properties || {};
      return String(pr._paciente_id   || '') === String(p.id != null ? p.id : '') &&
             String(pr._documento     || '') === String(p.documento     || '') &&
             String(pr._tipodocumento || '') === String(p.tipodocumento || '') &&
             String(pr._paciente_name || '') === nombre;
    });
  }

  function marcarPill(index) {
    var pillsContainer = document.getElementById('vlc-patient-pills');
    if (!pillsContainer) return;
    pillsContainer.querySelectorAll('.vlc-pill[data-patient-index]').forEach(function (btn) {
      btn.classList.toggle('vlc-pill--active', btn.dataset.patientIndex === String(index));
    });
  }

  /* ════════════════════════════════════
     CARGAR PACIENTE EN VISTA
     opciones.sinSync: no se sincroniza con el carrito (sus líneas ya lo tienen)
  ════════════════════════════════════ */
  function loadPacienteIntoView(p, index, opciones) {
    if (!p) return;
    _activePaciente = p;
    _activeIndex    = index;
    recordarPaciente(p);

    var esTitular = (index === 0);

    setVal('view-nombres',   pNombre(p)        || '—');
    setVal('view-apellidos', pApellido(p)      || '—');
    setVal('view-sexo',      p.sexo            || '—');
    setVal('view-fecha',     p.fechanacimiento || '—');
    setVal('view-documento', p.documento       || '—');
    setVal('view-telefono',  p.telefono        || '—');

    var emailMostrar = p.email
      ? p.email
      : (esTitular ? (_customer.email || '—') : '—');
    setVal('view-email', emailMostrar);

    var tipodocEl = document.getElementById('view-tipodoc');
    if (tipodocEl) { tipodocEl.value = p.tipodocumento || '—'; tipodocEl.dataset.raw = p.tipodocumento || ''; }

    var indicativoEl = document.getElementById('view-indicativo');
    if (indicativoEl) { indicativoEl.value = p.indicativo || '—'; indicativoEl.dataset.raw = p.indicativo || ''; }

    setVal('h-documento',       p.documento        || '');
    setVal('h-TipoDocumento',   p.tipodocumento    || '');
    setVal('h-fechanacimiento', p.fechanacimiento  || '');
    setVal('h-sexo',            p.sexo             || '');
    setVal('h-idIndicativo',    p.indicativo       || '');
    setVal('h-paciente-metaid', p.id               || '');
    setVal('h-depto-id',        p.departamento     || '');
    setVal('h-ciudad-id',       p.ciudad           || '');

    setVal('e-nombres',   pNombre(p)        || '');
    setVal('e-apellidos', pApellido(p)      || '');
    setVal('e-fecha',     p.fechanacimiento || '');
    setVal('e-documento', p.documento       || '');
    setVal('e-telefono',  p.telefono        || '');
    setVal('e-codPaisId', p.indicativo      || '');

    var emailEdicion = esTitular ? (_customer.email || '') : (p.email || '');
    setVal('e-newEmail', emailEdicion);

    var sexoSel = document.getElementById('e-sexo');
    if (sexoSel) Array.from(sexoSel.options).forEach(function (o) { o.selected = (o.value === p.sexo); });

    var tipodocSel = document.getElementById('e-tipodoc');
    if (tipodocSel) tipodocSel.dataset.selected = p.tipodocumento || '';

    var codPaisInput = document.getElementById('e-codPais');
    if (codPaisInput) {
      codPaisInput.dataset.selectedId = p.indicativo || '';
      codPaisInput.value = '';
      codPaisInput.removeAttribute('data-init-done');
    }

    /* Resetear feedback de documento al cambiar de paciente */
    _setEditDocExistsFeedback(false);
    _editDocExiste = false;

    var mainName   = document.getElementById('vlc-main-name');
    var mainEmail  = document.getElementById('vlc-main-email');
    var mainAvatar = document.getElementById('vlc-main-avatar');
    if (mainName)   mainName.textContent   = (pNombre(p) + ' ' + pApellido(p)).trim();
    if (mainAvatar) mainAvatar.textContent = getInitials(pNombre(p), pApellido(p));
    if (mainEmail)  mainEmail.textContent  = emailMostrar;

    resolveViewLabels(p);
    _selectsLoaded = false;

    if (!(opciones && opciones.sinSync)) syncPaciente(p);
  }

  function resolveViewLabels(p) {
    var tipodocEl    = document.getElementById('view-tipodoc');
    var indicativoEl = document.getElementById('view-indicativo');

    if (p.tipodocumento && p.tipodocumento !== '—' && base && tipodocEl) {
      fetch(base + 'ajax/genericConsult.php?action=ConsultDocumentType')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var found = data.find(function (i) {
            return i.abreviatura === p.tipodocumento || String(i.id) === String(p.tipodocumento);
          });
          if (found) {
            tipodocEl.value           = found.tipodocumento;
            document._vlcTipoDocAbrev = found.abreviatura;
            document._vlcTipoDocId    = String(found.id);
          }
        }).catch(console.error);
    }

    if (p.indicativo && p.indicativo !== '—' && base && indicativoEl) {
      fetch(base + 'ws/get_indicative.php')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var found = data.find(function (i) { return String(i.idRegistro) === String(p.indicativo); });
          if (found) {
            indicativoEl.value        = found.value + ' ' + found.cod_Indicativo;
            document._vlcIndicativoId = String(found.idRegistro);
          }
        }).catch(console.error);
    }
  }

  /* ════════════════════════════════════
     SELECTOR DE PACIENTES
  ════════════════════════════════════ */
  function initPatientSelector() {
    var pillsContainer = document.getElementById('vlc-patient-pills');
    if (!pillsContainer) return;

    pillsContainer.addEventListener('click', function (e) {
      var pill = e.target.closest('.vlc-pill[data-patient-index]');
      if (!pill) return;

      var idx = parseInt(pill.dataset.patientIndex, 10);
      var p   = _pacientes[idx];
      if (!p) return;

      pillsContainer.querySelectorAll('.vlc-pill[data-patient-index]').forEach(function (btn) {
        btn.classList.remove('vlc-pill--active');
      });
      pill.classList.add('vlc-pill--active');

      if (editEl && editEl.style.display !== 'none') {
        editEl.style.display  = 'none';
        viewEl.style.display  = 'block';
        btnEdit.style.display = '';
        form && form.classList.remove('was-validated');
        _editMode = 'edit';
        _setFormMode('edit');
      }

      // V15-M3: queda guardado en las líneas del carrito (syncPaciente) y en sessionStorage
      loadPacienteIntoView(p, idx);
    });

    var btnNuevo = document.getElementById('vlc-btn-nuevo');
    if (btnNuevo) {
      btnNuevo.addEventListener('click', function () { _openCreateMode(); });
    }
  }

  function _openCreateMode() {
    _editMode = 'create';
    _setFormMode('create');

    setVal('e-nombres',   '');
    setVal('e-apellidos', '');
    setVal('e-fecha',     '');
    setVal('e-documento', '');
    setVal('e-telefono',  '');
    setVal('e-codPaisId', '');

    var sexoSel = document.getElementById('e-sexo');
    if (sexoSel) sexoSel.selectedIndex = 0;

    var tipodocSel = document.getElementById('e-tipodoc');
    if (tipodocSel) { tipodocSel.selectedIndex = 0; tipodocSel.dataset.selected = ''; }

    var codPaisInput = document.getElementById('e-codPais');
    if (codPaisInput) {
      codPaisInput.value = '';
      codPaisInput.dataset.selectedId = '';
      codPaisInput.removeAttribute('data-init-done');
    }

    /* Limpiar feedback de documento al abrir modo creación */
    _setEditDocExistsFeedback(false);
    _editDocExiste = false;

    form && form.classList.remove('was-validated');
    var inputs = form ? form.querySelectorAll('.reg-input') : [];
    inputs.forEach(function (inp) { inp.classList.remove('is-valid', 'is-invalid'); });

    if (!_selectsLoaded) { _selectsLoaded = true; loadTipoDocumento(); loadIndicativo(); loadDepartamentos(); initValidaciones(); }

    viewEl.style.display  = 'none';
    editEl.style.display  = 'block';
    btnEdit.style.display = 'none';
  }

  function _setFormMode(mode) {
    var titleIcon  = document.querySelector('#vlc-edit-title .ti');
    var titleText  = document.getElementById('vlc-edit-title-text');
    var btnText    = document.getElementById('btn-save-text');
    var rowEmail   = document.getElementById('row-email-edit');
    var emailInput = document.getElementById('e-newEmail');
    var labelEmail = document.getElementById('label-email-edit');

    if (mode === 'create') {
      if (titleIcon)  titleIcon.className    = 'ti ti-user-plus';
      if (titleText)  titleText.textContent  = 'Nuevo paciente';
      if (btnText)    btnText.textContent    = 'Agregar paciente';
      if (rowEmail)   rowEmail.style.display = '';
      if (emailInput) {
        emailInput.setAttribute('required', '');
        emailInput.value       = '';
        emailInput.placeholder = 'Correo del paciente';
      }
      if (labelEmail) labelEmail.textContent = 'Correo del paciente';
    } else {
      if (titleIcon)  titleIcon.className    = 'ti ti-edit';
      if (titleText)  titleText.textContent  = 'Editar datos';
      if (btnText)    btnText.textContent    = 'Guardar cambios';
      if (rowEmail)   rowEmail.style.display = '';
      if (emailInput) {
        emailInput.setAttribute('required', '');
        emailInput.placeholder = 'Correo electrónico';
      }
      if (labelEmail) labelEmail.textContent = 'Correo electrónico';
    }
  }

  function _addPacientePill(p, index) {
    var pillsContainer = document.getElementById('vlc-patient-pills');
    var btnNuevo       = document.getElementById('vlc-btn-nuevo');
    if (!pillsContainer || !btnNuevo) return;

    var nombre   = pNombre(p);
    var apellido = pApellido(p);
    var initials = getInitials(nombre, apellido);
    var fullName = (nombre + ' ' + apellido).trim() || 'Sin nombre';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vlc-pill';
    btn.dataset.patientIndex = String(index);
    btn.setAttribute('aria-label', 'Seleccionar paciente ' + fullName);
    btn.innerHTML =
      '<span class="vlc-pill__avatar">' + initials + '</span>' +
      '<span class="vlc-pill__name">'   + fullName  + '</span>' +
      '<span class="vlc-pill__dot" aria-hidden="true"></span>';

    pillsContainer.insertBefore(btn, btnNuevo);
  }

  /* ── Init titular ──
     Etiquetas de la vista que pinta Liquid (la del titular). V15-M3: si mientras tanto se
     restauró otro paciente, su propia consulta (resolveViewLabels) es la que manda. */
  (function initFirstPatient() {
    var tipodocEl     = document.getElementById('view-tipodoc');
    var rawTipoDoc    = tipodocEl    ? (tipodocEl.dataset.raw    || tipodocEl.value)    : '';
    var indicativoEl  = document.getElementById('view-indicativo');
    var rawIndicativo = indicativoEl ? (indicativoEl.dataset.raw || indicativoEl.value) : '';

    if (rawTipoDoc && rawTipoDoc !== '—' && base) {
      fetch(base + 'ajax/genericConsult.php?action=ConsultDocumentType')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (_activeIndex !== 0) return;
          var found = data.find(function (i) {
            return i.abreviatura === rawTipoDoc || String(i.id) === String(rawTipoDoc);
          });
          if (found) {
            setVal('view-tipodoc', found.tipodocumento);
            document._vlcTipoDocAbrev = found.abreviatura;
            document._vlcTipoDocId    = String(found.id);
          }
        }).catch(console.error);
    }

    if (rawIndicativo && rawIndicativo !== '—' && base) {
      fetch(base + 'ws/get_indicative.php')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (_activeIndex !== 0) return;
          var found = data.find(function (i) { return String(i.idRegistro) === String(rawIndicativo); });
          if (found) {
            setVal('view-indicativo', found.value + ' ' + found.cod_Indicativo);
            document._vlcIndicativoId = String(found.idRegistro);
          }
        }).catch(console.error);
    }
  })();

  initPatientSelector();

  /* ── V15-M3: paciente activo al cargar (también al entrar directo al paso 4 con ?tab=pago) ──
     Antes se sincronizaba siempre el primero y se reescribían las líneas con él. Orden:
     1. El que ya está en las líneas del carrito (_paciente_id), la fuente que sobrevive a la recarga.
     2. Si las líneas no lo dicen (sin paciente, o a medio escribir), el último escogido en esta pestaña.
     3. El de «Guardar cambios» (vlc_active_index, se guarda antes de volver con ?tab=contacto).
     4. El titular.
     Si las líneas ya tienen sus datos, no se reescriben: solo se marca como paciente activo y se
     repinta el paso 4. Si no (otro paciente o datos editados), se sincroniza como al escogerlo. */
  (function restaurarPaciente() {
    if (!_pacientes.length) return;

    var trasGuardar = -1;
    try {
      trasGuardar = parseInt(sessionStorage.getItem('vlc_active_index') || '', 10);
      sessionStorage.removeItem('vlc_active_index');
    } catch (e) {}
    var idRecordado = pacienteRecordado();

    function activar(cart) {
      var idx = cart ? indicePorId(idEnLineas(cart)) : -1;
      if (idx < 0) idx = indicePorId(idRecordado);
      if (idx < 0 && trasGuardar > 0 && _pacientes[trasGuardar]) idx = trasGuardar;
      if (idx < 0) idx = 0;

      var p = _pacientes[idx];
      marcarPill(idx);

      if (cart && lineasAlDia(cart, p)) {
        loadPacienteIntoView(p, idx, { sinSync: true });
        // Lo que cart-data-pay usa para pintar el paso 4 y para pagar; el cart:updated lo repinta
        window.__vtlActivePaciente = p;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cartData: cart } }));
        return;
      }
      loadPacienteIntoView(p, idx);
    }

    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(activar, function (e) {
        // Sin carrito no se sabe si las líneas están al día: se sincroniza el escogido, como antes
        console.warn('[vlc] No se pudo leer el carrito para restaurar el paciente:', e);
        activar(null);
      });
  })();

  /* ════════════════════════════════════
     EDIT — Tipo de documento
  ════════════════════════════════════ */
  function loadTipoDocumento() {
    var tipoDoc = document.getElementById('e-tipodoc');
    if (!tipoDoc || !base) return;
    var selected = _editMode === 'edit'
      ? (document._vlcTipoDocAbrev || tipoDoc.dataset.selected || (_activePaciente && _activePaciente.tipodocumento) || '')
      : '';
    fetch(base + 'ajax/genericConsult.php?action=ConsultDocumentType')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        tipoDoc.innerHTML = '<option value="">Tipo doc.</option>';
        data.forEach(function (item) {
          var opt = document.createElement('option');
          opt.text = item.tipodocumento; opt.value = String(item.id); opt.dataset.abrev = item.abreviatura;
          if (selected && (item.abreviatura === selected || String(item.id) === String(selected))) opt.selected = true;
          tipoDoc.add(opt);
        });
        /* Vincular listener de existencia una vez que el select tiene opciones */
        _bindTipoDocListener();
      }).catch(console.error);
  }

  /* ════════════════════════════════════
     EDIT — Indicativo
  ════════════════════════════════════ */
  function loadIndicativo() {
    var codPaisInput = document.getElementById('e-codPais');
    var codPaisId    = document.getElementById('e-codPaisId');
    if (!codPaisInput || codPaisInput.dataset.initDone || !base) return;
    codPaisInput.dataset.initDone = '1';
    var selectedId = _editMode === 'edit'
      ? (document._vlcIndicativoId || codPaisInput.dataset.selectedId || (_activePaciente && _activePaciente.indicativo) || '')
      : '';
    fetch(base + 'ws/get_indicative.php')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (selectedId) {
          var found = data.find(function (i) { return String(i.idRegistro) === String(selectedId); });
          if (found) {
            codPaisInput.value = found.value + ' ' + found.cod_Indicativo;
            codPaisId.value    = String(found.idRegistro);
            setVal('h-idIndicativo', String(found.idRegistro));
          }
        }
        $(codPaisInput).autocomplete({
          minLength: 0, source: data,
          focus: function (ev, ui) { codPaisInput.value = ui.item.value; return false; },
          select: function (ev, ui) {
            codPaisInput.value = ui.item.value + ' ' + ui.item.cod_Indicativo;
            codPaisId.value    = ui.item.idRegistro;
            setVal('h-idIndicativo', ui.item.idRegistro);
            $(codPaisInput).addClass('is-valid').removeClass('is-invalid');
            return false;
          }
        });
        $(codPaisInput).on('click', function () { $(this).autocomplete('search', ''); });
        $(codPaisInput).on('blur', function () {
          var pais   = norm($(this).val().split('+')[0]);
          var src    = $(this).autocomplete('option', 'source');
          var valido = src.some(function (i) { return norm(i.value) === pais; });
          if (!valido || codPaisId.value === '') {
            $(this).addClass('is-invalid').removeClass('is-valid');
            $(this).val(''); codPaisId.value = ''; setVal('h-idIndicativo', '');
          } else {
            $(this).addClass('is-valid').removeClass('is-invalid');
          }
        });
      }).catch(console.error);
  }

  /* ════════════════════════════════════
     EDIT — Departamentos + Ciudades
  ════════════════════════════════════ */
  function loadDepartamentos() {
    var dSelect = document.getElementById('vlc-DepartamentoC');
    if (!dSelect || !base) return;
    var deptoIdGuardado    = (dSelect.dataset.selectedId   || getVal('h-depto-id')  || '').trim();
    var deptoTextoGuardado = norm(dSelect.dataset.selectedText || getVal('h-provincia') || '');
    var cSelectOrig        = document.getElementById('vlc-AddressCityNew');
    var ciudadIdGuardada   = ((cSelectOrig && cSelectOrig.dataset.selectedId)   || getVal('h-ciudad-id') || '').trim();
    var ciudadTextoGuardada= norm((cSelectOrig && cSelectOrig.dataset.selectedText) || getVal('h-ciudad') || '');
    fetch(base + 'ajax/genericConsult.php?action=consultDepartment')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        data.forEach(function (item) {
          var opt = new Option(item.depto, item.id);
          if ((deptoIdGuardado && String(item.id) === deptoIdGuardado) || (deptoTextoGuardado && norm(item.depto) === deptoTextoGuardado)) opt.selected = true;
          dSelect.add(opt);
        });
        var sel = dSelect.options[dSelect.selectedIndex];
        if (sel && sel.value) { window._depto = sel.text; cargarCiudades(sel.value, ciudadIdGuardada, ciudadTextoGuardada); }
        dSelect.addEventListener('change', function () { window._depto = this.selectedOptions[0]?.text || ''; cargarCiudades(this.value, '', ''); });
      }).catch(console.error);
  }

  function cargarCiudades(deptoId, ciudadIdGuardada, ciudadTextoGuardada) {
    var ciudadWrap = document.getElementById('vlc-ciudad-wrap');
    var cSelect    = document.getElementById('vlc-AddressCityNew');
    if (!cSelect || !base) return;
    fetch(base + 'ajax/genericConsult.php?action=consultCitDepartment&departament_Id=' + deptoId)
      .then(function (r) { return r.json(); })
      .then(function (cities) {
        if (!cities || !cities.length) { ciudadWrap && (ciudadWrap.style.display = 'none'); return; }
        ciudadWrap && (ciudadWrap.style.display = 'block');
        var fresh = cSelect.cloneNode(false);
        fresh.innerHTML = '<option value="">Ciudad</option>';
        cities.forEach(function (c) {
          var opt = new Option(c.ciudad, c.id);
          if ((ciudadIdGuardada && String(c.id) === ciudadIdGuardada) || (ciudadTextoGuardada && norm(c.ciudad) === ciudadTextoGuardada)) opt.selected = true;
          fresh.add(opt);
        });
        fresh.addEventListener('change', function () { window._city = this.selectedOptions[0]?.text || ''; });
        cSelect.replaceWith(fresh);
        var sel = fresh.options[fresh.selectedIndex];
        if (sel && sel.value) window._city = sel.text;
      }).catch(console.error);
  }

  /* ════════════════════════════════════
     VALIDACIONES
  ════════════════════════════════════ */
  function initValidaciones() {
    /* Documento — sanitización + existencia en sistema */
    var docInput = document.getElementById('e-documento');
    if (docInput && !docInput.dataset.initDone) {
      docInput.dataset.initDone = '1';
      docInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^a-zA-Z0-9\-]/g, '');
        this.setCustomValidity(
          this.value.length < 3  ? 'Mínimo 3 caracteres.'  :
          this.value.length > 20 ? 'Máximo 20 caracteres.' : ''
        );
        if (this.value.length < 3) {
          clearTimeout(_editDocTimer);
          _setEditDocExistsFeedback(false);
          _editDocExiste = false;
          return;
        }
        clearTimeout(_editDocTimer);
        _editDocTimer = setTimeout(_checkEditDocumento, 600);
      });
    }

    var telInput = document.getElementById('e-telefono');
    if (telInput && !telInput.dataset.initDone) {
      telInput.dataset.initDone = '1';
      telInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        this.setCustomValidity(this.value.length < 7 ? 'Mínimo 7 dígitos.' : this.value.length > 15 ? 'Máximo 15 dígitos.' : '');
      });
    }

    var fechaInput = document.getElementById('e-fecha');
    if (fechaInput && !fechaInput.dataset.initDone) {
      fechaInput.dataset.initDone = '1';
      var hoy = new Date();
      /* R5: se aceptan recién nacidos, como en el CTS. */
      fechaInput.max = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).toISOString().split('T')[0];
      fechaInput.min = new Date(hoy.getFullYear()-120, hoy.getMonth(), hoy.getDate()).toISOString().split('T')[0];
      function validarFecha() {
        var val = fechaInput.value;
        if (!val) { fechaInput.setCustomValidity('La fecha es obligatoria.'); return; }
        var fecha = new Date(val + 'T00:00:00'); var hoyMs = new Date(); hoyMs.setHours(0,0,0,0);
        if (isNaN(fecha.getTime()) || fecha > hoyMs) { fechaInput.setCustomValidity('Fecha no válida.'); return; }
        var edad = hoyMs.getFullYear() - fecha.getFullYear();
        var diff = hoyMs.getMonth() - fecha.getMonth();
        if (diff < 0 || (diff === 0 && hoyMs.getDate() < fecha.getDate())) edad--;
        if (edad > 120) { fechaInput.setCustomValidity('Fecha no válida.'); return; }
        fechaInput.setCustomValidity('');
      }
      fechaInput.addEventListener('change', validarFecha);
      fechaInput.addEventListener('blur',   validarFecha);
      if (fechaInput.value) validarFecha();
    }

    /* Tipo doc: re-bind listener de existencia (por si loadTipoDocumento no había terminado) */
    _bindTipoDocListener();
  }

  /* ════════════════════════════════════
     HELPERS FormData compartidos
  ════════════════════════════════════ */
  function _buildFormData(pac, esDomicilio, selectedAddr) {
    var esTitular = (_activeIndex === 0);
    var tit       = _pacientes[0];
    var pacNArr   = (pNombre(pac)).split(/\s+/).filter(Boolean);
    var pacAArr   = (pApellido(pac)).split(/\s+/).filter(Boolean);
    var sexoMap   = { 'Hombre': '1', 'Mujer': '2' };

    var fd = new FormData();
    fd.append('email',       _customer.email || getVal('h-email'));
    fd.append('paciente_id', pac.id || getVal('h-paciente-metaid'));

    if (esTitular) {
      fd.append('nombres',         pNombre(pac));
      fd.append('apellidos',       pApellido(pac));
      fd.append('primerNombre',    pacNArr[0]                 || '');
      fd.append('segundoNombre',   pacNArr.slice(1).join(' ') || '');
      fd.append('primerApellido',  pacAArr[0]                 || '');
      fd.append('segundoApellido', pacAArr.slice(1).join(' ') || '');
      fd.append('documento',       pac.documento              || '');
      fd.append('TipoDocumento',   pac.tipodocumento          || '');
      fd.append('telefono',        (pac.telefono || '').replace(/\D/g, ''));
      fd.append('idIndicativo',    String(pac.indicativo      || ''));
      fd.append('sexo',            String(sexoMap[pac.sexo] ?? pac.sexo_id ?? '1'));
      fd.append('fechanacimiento', pac.fechanacimiento        || '');
      fd.append('newEmail',        _customer.email            || '');
      fd.append('paciente_index',  0);
    } else {
      var titNArr = (pNombre(tit)).split(/\s+/).filter(Boolean);
      var titAArr = (pApellido(tit)).split(/\s+/).filter(Boolean);
      fd.append('nombres',             pNombre(tit));
      fd.append('apellidos',           pApellido(tit));
      fd.append('primerNombre',        titNArr[0]                 || '');
      fd.append('segundoNombre',       titNArr.slice(1).join(' ') || '');
      fd.append('primerApellido',      titAArr[0]                 || '');
      fd.append('segundoApellido',     titAArr.slice(1).join(' ') || '');
      fd.append('documento',           tit.documento              || '');
      fd.append('TipoDocumento',       tit.tipodocumento          || '');
      fd.append('telefono',            (tit.telefono || '').replace(/\D/g, ''));
      fd.append('idIndicativo',        String(tit.indicativo      || ''));
      fd.append('sexo',                String(tit.sexo_id         || '1'));
      fd.append('fechanacimiento',     tit.fechanacimiento        || '');
      fd.append('newEmail',            _customer.email);
      fd.append('paciente_index',      _activeIndex);
      fd.append('sec_primerNombre',    pacNArr[0]                 || '');
      fd.append('sec_segundoNombre',   pacNArr.slice(1).join(' ') || '');
      fd.append('sec_primerApellido',  pacAArr[0]                 || '');
      fd.append('sec_segundoApellido', pacAArr.slice(1).join(' ') || '');
      fd.append('sec_documento',       pac.documento              || '');
      fd.append('sec_TipoDocumento',   pac.tipodocumento          || '');
      fd.append('sec_telefono',        (pac.telefono || '').replace(/\D/g, ''));
      fd.append('sec_idIndicativo',    String(pac.indicativo      || ''));
      fd.append('sec_sexo',            String(sexoMap[pac.sexo] ?? pac.sexo_id ?? '1'));
      fd.append('sec_fechanacimiento', pac.fechanacimiento        || '');
      fd.append('sec_email',           pac.email                  || '');
    }

    if (esDomicilio && selectedAddr) {
      fd.append('province',    selectedAddr.province || '');
      fd.append('city',        selectedAddr.city     || '');
      fd.append('direccion',   selectedAddr.address1 || '');
      fd.append('complemento', selectedAddr.address2 || '');
    }

    return fd;
  }

  /* ════════════════════════════════════
     VALIDAR DATOS ANTES DE CONTINUAR
  ════════════════════════════════════ */
  function _validarYContinuar(onSuccess) {
    var viewInputs = document.querySelectorAll('#vlc-view .reg-input[disabled]');
    var faltantes  = [];
    var ignorar    = ['Correo electrónico'];
    viewInputs.forEach(function (input) {
      var label = input.closest('.reg-field')?.querySelector('.vlc-label')?.textContent?.trim() || '';
      var val   = (input.value || '').trim();
      if (!ignorar.includes(label) && (val === '' || val === '—')) faltantes.push(label);
    });

    if (faltantes.length > 0) {
      // H1: se cuenta cuántos datos faltan, no cuáles (las etiquetas son textos de la pantalla)
      if (window.vtlMetrica) window.vtlMetrica('campo_error', { step: 3, detail: 'datos_incompletos', data: { faltantes: faltantes.length } });
      var mensaje = 'Para continuar debes completar los siguientes datos:<br><ul style="text-align:left;margin:8px 0 0;padding-left:20px;">'
        + faltantes.map(function (f) { return '<li>' + f + '</li>'; }).join('')
        + '</ul><br>Haz clic en <strong>Editar datos</strong> para completarlos.';
      if (typeof Swal !== 'undefined') {
        Swal.fire({
          html: '<div style="text-align:center"><strong style="font-size:16px;color:#e6007e;">Datos incompletos</strong><div style="margin-top:10px;font-size:14px;">' + mensaje + '</div></div>',
          showConfirmButton: true, confirmButtonText: 'Entendido', confirmButtonColor: '#e6007e',
          showCloseButton: true, allowOutsideClick: false,
        }).then(function () {
          var b = document.getElementById('btn-edit');
          if (b) { b.style.animation = 'vtl-pulse 0.4s ease 3'; setTimeout(function () { b.style.animation = ''; }, 1200); }
        });
      }
      return;
    }

    var esDomicilio  = Number(document.getElementById('tipo_servicio')?.value) === 3;
    var selectedAddr = null;

    if (esDomicilio) {
      selectedAddr = (window.AddressManager && window.AddressManager.getSelected)
        ? window.AddressManager.getSelected() : null;

      if (!selectedAddr) {
        if (window.vtlMetrica) window.vtlMetrica('campo_error', { step: 3, detail: 'sin_direccion' });
        if (typeof Swal !== 'undefined') {
          Swal.fire({
            html: '<div style="text-align:center"><strong style="font-size:16px;color:#e6007e;">Dirección requerida</strong><div style="margin-top:10px;font-size:14px;">Por favor selecciona o agrega una dirección de entrega.</div></div>',
            confirmButtonText: 'Entendido', confirmButtonColor: '#e6007e',
            showCloseButton: true, allowOutsideClick: false,
          }).then(function () {
            if (window.AddressManager && window.AddressManager.open) window.AddressManager.open();
          });
        }
        return;
      }
    }

    var pac = _pacientes[_activeIndex];
    if (!pac) { showMsg('No hay paciente activo', false); return; }

    onSuccess(_buildFormData(pac, esDomicilio, selectedAddr));
  }

  /* ── C2: continuar al pago ──────────────────────────────────────
     Antes el avance dependía de que update_patient.php respondiera, sin
     tiempo límite, y el error era un aviso que se borraba a los 4 s.
     Ahora: si responde con un error real, el mensaje queda junto al botón.
     Si tarda más de 10 s o falla la red, el cliente decide entre reintentar
     o seguir con los datos ya guardados (H6: antes avanzaba sin avisarle que
     sus cambios no se guardaron). */
  var UPDATE_TIMEOUT_MS = 10000;
  var _continuando      = false;

  function _errorContinuar(msg) {
    var btn = document.getElementById('btn-continuar-pago');
    var el  = document.getElementById('vtl-continuar-error');
    if (!msg) { if (el) el.hidden = true; return; }
    if (!el && btn) {
      el = document.createElement('p');
      el.id = 'vtl-continuar-error';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'margin:8px 0 0;padding:10px 12px;border-radius:8px;background:#fff0f6;color:#e31c79;font-size:.86rem;line-height:1.4';
      btn.insertAdjacentElement('afterend', el);
    }
    if (el) { el.textContent = msg; el.hidden = false; }
    else    { showMsg(msg, false); }
  }

  function _continuarAlPago(fd, origen) {
    if (_continuando) return;
    _continuando = true;
    _errorContinuar('');
    loading('show');

    // H1: el paso 3 con cuenta deja el mismo evento que el formulario sin cuenta
    var avanzar = function (data) {
      if (window.vtlMetrica) window.vtlMetrica('paso_3_ok', { step: 3, detail: 'con_cuenta', data: data });
      if (typeof StepperAPI !== 'undefined') StepperAPI.goTo(4);
    };
    var ctrl    = new AbortController();
    var timer   = setTimeout(function () { ctrl.abort(); }, UPDATE_TIMEOUT_MS);

    fetch(base + 'ws/update_patient.php', { method: 'POST', body: fd, signal: ctrl.signal })
      .then(function (res) { return res.json(); })
      .then(function (result) {
        if (result.error == 0) avanzar();
        else {
          _errorContinuar(result.message || 'No pudimos guardar los datos del paciente. Revisa la información e intenta de nuevo.');
          if (window.vtlMetrica) window.vtlMetrica('guardar_error', { step: 3, detail: 'con_cuenta', data: { tipo: 'respuesta' } });
        }
      })
      .catch(function (err) {
        console.warn(origen + ': update_patient no respondió', err);
        _errorContinuar('No pudimos guardar los cambios del paciente.');
        if (window.vtlMetrica) window.vtlMetrica('guardar_error', { step: 3, detail: 'con_cuenta', data: { tipo: err && err.name === 'AbortError' ? 'tiempo' : 'red' } });
        if (typeof Swal === 'undefined') return;
        Swal.fire({
          html: '<div style="text-align:center"><strong style="font-size:16px;color:#e6007e;">No pudimos guardar los cambios</strong>' +
                '<div style="margin-top:10px;font-size:14px;">El servidor no respondió. Si continúas, la compra sigue con los datos del paciente que ya teníamos guardados.</div></div>',
          showCancelButton: true,
          confirmButtonText: 'Reintentar',
          cancelButtonText: 'Continuar con los datos guardados',
          confirmButtonColor: '#e6007e',
          reverseButtons: true,
        }).then(function (r) {
          if (r.isConfirmed) _continuarAlPago(fd, origen);
          else if (r.dismiss === Swal.DismissReason.cancel) { _errorContinuar(''); avanzar({ sin_guardar: true }); }
        });
      })
      .finally(function () {
        clearTimeout(timer);
        _continuando = false;
        loading('hide');
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#btn-continuar-pago')) return;
    _validarYContinuar(function (fd) { _continuarAlPago(fd, 'continuar-pago'); });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#vtl-btn-back-register')) return;
    if (typeof StepperAPI !== 'undefined') StepperAPI.goTo(2);
  });

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.cart-accordion__trigger');
    if (!trigger) return;
    var item     = trigger.closest('.cart-accordion__item');
    var accIndex = parseInt(item?.dataset.accordionIndex);
    if (accIndex !== 3) return;
    e.stopImmediatePropagation();

    _validarYContinuar(function (fd) { _continuarAlPago(fd, 'accordion-pago'); });
  });

  /* ════════════════════════════════════
     TOGGLE VISTA ↔ EDICIÓN
  ════════════════════════════════════ */
  var _selectsLoaded = false;

  if (btnEdit) {
    btnEdit.addEventListener('click', function () {
      _editMode = 'edit';
      _setFormMode('edit');
      var pac = _pacientes[_activeIndex];
      if (pac) {
        var emailEdicion = (_activeIndex === 0)
          ? (_customer.email || '')
          : (pac.email || '');
        setVal('e-newEmail', emailEdicion);
      }
      /* Limpiar feedback de documento al abrir edición */
      _setEditDocExistsFeedback(false);
      _editDocExiste = false;

      viewEl.style.display  = 'none';
      editEl.style.display  = 'block';
      btnEdit.style.display = 'none';
      if (!_selectsLoaded) { _selectsLoaded = true; loadTipoDocumento(); loadIndicativo(); loadDepartamentos(); initValidaciones(); }
    });
  }

  if (btnCancel) {
    btnCancel.addEventListener('click', function () {
      editEl.style.display  = 'none';
      viewEl.style.display  = 'block';
      btnEdit.style.display = '';
      form && form.classList.remove('was-validated');
      _editMode = 'edit';
      _setFormMode('edit');
      /* Limpiar feedback al cancelar */
      _setEditDocExistsFeedback(false);
      _editDocExiste = false;
      /* R5: el aviso de documento por edad (cart-document-age-validator.js)
         seguía bloqueando "Continuar al pago" después de cancelar. */
      window._editDocAgeInvalid = false;
      var ageFb = document.getElementById('doc-age-feedback-edit');
      if (ageFb) { ageFb.style.display = 'none'; ageFb.textContent = ''; ageFb.className = 'doc-age-feedback'; }
      ['e-tipodoc', 'e-documento'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.classList.remove('doc-age-error', 'doc-age-warning');
      });
    });
  }

  /* ════════════════════════════════════
     GUARDAR CAMBIOS / CREAR PACIENTE
  ════════════════════════════════════ */
  if (btnSave) {
    btnSave.addEventListener('click', async function () {

      // H1: errores del formulario de paciente con cuenta (nombre del campo, nunca el valor)
      var errorCampo = function (detalle, data) {
        if (window.vtlMetrica) window.vtlMetrica('campo_error', { step: 3, detail: detalle, data: Object.assign({ formulario: _editMode === 'create' ? 'nuevo_paciente' : 'editar_paciente' }, data || {}) });
      };

      form.classList.add('was-validated');
      if (!form.checkValidity()) {
        var invalidos = Array.prototype.map.call(form.querySelectorAll(':invalid'), function (c) { return c.name || c.id; }).filter(Boolean);
        errorCampo(invalidos[0] || null, { campos: invalidos });
        form.reportValidity();
        return;
      }

      var tel = (getVal('e-telefono') || '').replace(/\D/g, '');
      if (tel.length < 7) { errorCampo('telefono_corto'); showMsg('El teléfono debe tener al menos 7 dígitos', false); return; }

      var codPaisId = getVal('e-codPaisId') || getVal('h-idIndicativo') || document._vlcIndicativoId || '';
      if (!codPaisId) { errorCampo('indicativo'); showMsg('Por favor selecciona el indicativo del país', false); return; }

      /* ── Bloquear si el documento ya existe en sistema ── */
      if (_editDocExiste) {
        errorCampo('documento_registrado');
        showMsg('El tipo y número de documento ingresado ya se encuentra registrado en el sistema.', false);
        return;
      }

      /* ─────────────────────────────
         MODO CREAR — new_paciente.php
      ───────────────────────────── */
      if (_editMode === 'create') {

        var pacientesMetafieldRaw = getVal('vlc-pacientes-metafield');
        if (!pacientesMetafieldRaw) { showMsg('No se pudo obtener la información del paciente titular', false); return; }

        var emailPaciente = (getVal('e-newEmail') || '').trim();
        if (!emailPaciente || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailPaciente)) {
          showMsg('Por favor ingresa un correo válido para el paciente', false);
          return;
        }

        btnSave.disabled = true;
        document.getElementById('btn-save-text').textContent = 'Guardando...';
        loading('show');

        var nombresRaw   = (getVal('e-nombres')   || '').trim();
        var apellidosRaw = (getVal('e-apellidos') || '').trim();
        var nArr = nombresRaw.split(/\s+/).filter(Boolean);
        var aArr = apellidosRaw.split(/\s+/).filter(Boolean);

        var sexoEl    = document.getElementById('e-sexo');
        var sexoTexto = sexoEl ? sexoEl.value : '';

        var fd = new FormData();
        fd.append('nombres',             nombresRaw);
        fd.append('apellidos',           apellidosRaw);
        fd.append('primerNombre',        nArr[0]                 || '');
        fd.append('segundoNombre',       nArr.slice(1).join(' ') || '');
        fd.append('primerApellido',      aArr[0]                 || '');
        fd.append('segundoApellido',     aArr.slice(1).join(' ') || '');
        fd.append('email',               _customer.email         || getVal('vlc-customer-email'));
        fd.append('email_paciente',      emailPaciente);
        fd.append('telefono',            tel);
        fd.append('idIndicativo',        codPaisId);
        fd.append('documento',           getVal('e-documento'));
        fd.append('TipoDocumento',       (document.getElementById('e-tipodoc') || {}).value || '');
        fd.append('fechanacimiento',     getVal('e-fecha'));
        fd.append('sexo',                sexoTexto);
        fd.append('customer_id',         _customer.id            || getVal('vlc-customer-id'));
        fd.append('pacientes_metafield', pacientesMetafieldRaw);

        try {
          var res    = await fetchConTiempo(base + 'ws/new_paciente.php', { method: 'POST', body: fd });
          var result = await res.json();

          showMsg(result.message, result.error == 0);

          if (result.error == 0) {

            /* ── Resolver id devuelto por el servidor ── */
            var pacienteIdNuevo = String(result.paciente_id || '').trim();
            if (!pacienteIdNuevo) {
              console.warn('[vlc] new_paciente.php no devolvió paciente_id. Respuesta completa:', result);
            }

            var sexoIdMap  = { 'Hombre': 1, 'Mujer': 2 };
            var tipoDocEl2 = document.getElementById('e-tipodoc');

            var newP = {
              id:              pacienteIdNuevo,
              email:           emailPaciente,
              name:            (nArr[0] || '') + ' ' + (aArr[0] || ''),
              primerNombre:    nArr[0]                  || '',
              segundoNombre:   nArr.slice(1).join(' ')  || '',
              nombres:         nombresRaw,
              primerApellido:  aArr[0]                  || '',
              segundoApellido: aArr.slice(1).join(' ')  || '',
              apellidos:       apellidosRaw,
              documento:       getVal('e-documento'),
              tipodocumento:   (tipoDocEl2 ? tipoDocEl2.value : '') || '',
              telefono:        tel,
              indicativo:      codPaisId,
              sexo:            sexoTexto,
              sexo_id:         sexoIdMap[sexoTexto] || 1,
              fechanacimiento: getVal('e-fecha')
            };

            var newIndex = _pacientes.length;
            _pacientes.push(newP);

            /* ── Actualizar metafield en el input hidden ── */
            var metaInput = document.getElementById('vlc-pacientes-metafield');
            if (metaInput) {
              var metaObj = { pacientes: _pacientes };
              metaInput.value = JSON.stringify(metaObj).replace(/"/g, '&quot;');
            }

            /* ── Agregar pill y activarla ── */
            _addPacientePill(newP, newIndex);

            var pillsContainer = document.getElementById('vlc-patient-pills');
            if (pillsContainer) {
              pillsContainer.querySelectorAll('.vlc-pill[data-patient-index]').forEach(function (btn) {
                btn.classList.remove('vlc-pill--active');
              });
              var newPill = pillsContainer.querySelector('[data-patient-index="' + newIndex + '"]');
              if (newPill) newPill.classList.add('vlc-pill--active');
            }

            /* ── Volver a vista de lectura con el nuevo paciente ── */
            setTimeout(function () {
              _editMode = 'edit';
              _setFormMode('edit');
              loadPacienteIntoView(newP, newIndex);
              editEl.style.display  = 'none';
              viewEl.style.display  = 'block';
              btnEdit.style.display = '';
              form && form.classList.remove('was-validated');
            }, 1200);
          }

        } catch (err) {
          console.error('new_paciente:', err);
          showMsg('Error al crear el paciente', false);
        } finally {
          loading('hide');
          btnSave.disabled = false;
          document.getElementById('btn-save-text').textContent = 'Agregar paciente';
        }

        return;
      }

      /* ─────────────────────────────
         MODO EDITAR — update_patient.php
      ───────────────────────────── */
      var newEmail = (getVal('e-newEmail') || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newEmail)) { showMsg('El correo no tiene un formato válido', false); return; }

      var esTitular = (_activeIndex === 0);

      if (!esTitular) {
        var titular = _pacientes[0];
        if (!titular || !titular.telefono || !titular.indicativo || !titular.documento ||
            !titular.tipodocumento || !titular.fechanacimiento || !titular.sexo_id) {
          showMsg('El paciente titular debe tener todos sus datos completos antes de editar un paciente secundario.', false);
          return;
        }
      }

      btnSave.disabled = true;
      document.getElementById('btn-save-text').textContent = 'Guardando...';
      loading('show');

      var nombresArr   = (getVal('e-nombres')   || '').trim().split(/\s+/).filter(Boolean);
      var apellidosArr = (getVal('e-apellidos') || '').trim().split(/\s+/).filter(Boolean);
      var primerNombre    = nombresArr[0]                  || '';
      var segundoNombre   = nombresArr.slice(1).join(' ')  || '';
      var primerApellido  = apellidosArr[0]                || '';
      var segundoApellido = apellidosArr.slice(1).join(' ')|| '';

      var tipoDocEl       = document.getElementById('e-tipodoc');
      var sexoEl2         = document.getElementById('e-sexo');
      var TipoDocumento   = (tipoDocEl && tipoDocEl.value)  || getVal('h-TipoDocumento')    || '';
      var sexo            = (sexoEl2   && sexoEl2.value)    || getVal('h-sexo')             || '';
      var documento       = getVal('e-documento')           || getVal('h-documento')        || '';
      var fechanacimiento = getVal('e-fecha')               || getVal('h-fechanacimiento')  || '';
      var emailActual     = getVal('h-email');
      var pacienteId      = getVal('h-paciente-metaid');

      var sexoMap2 = { 'Hombre': '1', 'Mujer': '2' };
      var sexoId   = sexoMap2[sexo] !== undefined ? sexoMap2[sexo] : sexo;

      var fd = new FormData();
      fd.append('email',       emailActual);
      fd.append('paciente_id', pacienteId);

      if (esTitular) {
        fd.append('nombres',         (primerNombre + ' ' + segundoNombre).trim());
        fd.append('apellidos',       (primerApellido + ' ' + segundoApellido).trim());
        fd.append('primerNombre',    primerNombre);
        fd.append('segundoNombre',   segundoNombre);
        fd.append('primerApellido',  primerApellido);
        fd.append('segundoApellido', segundoApellido);
        fd.append('documento',       documento);
        fd.append('TipoDocumento',   TipoDocumento);
        fd.append('telefono',        tel);
        fd.append('idIndicativo',    codPaisId);
        fd.append('sexo',            sexoId);
        fd.append('fechanacimiento', fechanacimiento);
        fd.append('newEmail',        newEmail);
        fd.append('paciente_index',  0);
      } else {
        var tit2    = _pacientes[0];
        var titNArr = (pNombre(tit2)).split(/\s+/).filter(Boolean);
        var titAArr = (pApellido(tit2)).split(/\s+/).filter(Boolean);
        fd.append('nombres',             pNombre(tit2));
        fd.append('apellidos',           pApellido(tit2));
        fd.append('primerNombre',        titNArr[0]                 || '');
        fd.append('segundoNombre',       titNArr.slice(1).join(' ') || '');
        fd.append('primerApellido',      titAArr[0]                 || '');
        fd.append('segundoApellido',     titAArr.slice(1).join(' ') || '');
        fd.append('documento',           tit2.documento             || '');
        fd.append('TipoDocumento',       tit2.tipodocumento         || '');
        fd.append('telefono',            (tit2.telefono || '').replace(/\D/g, ''));
        fd.append('idIndicativo',        String(tit2.indicativo     || ''));
        fd.append('sexo',                String(tit2.sexo_id        || '1'));
        fd.append('fechanacimiento',     tit2.fechanacimiento       || '');
        fd.append('newEmail',            _customer.email);
        fd.append('paciente_index',      _activeIndex);
        fd.append('sec_email',           newEmail);
        fd.append('sec_primerNombre',    primerNombre);
        fd.append('sec_segundoNombre',   segundoNombre);
        fd.append('sec_primerApellido',  primerApellido);
        fd.append('sec_segundoApellido', segundoApellido);
        fd.append('sec_documento',       documento);
        fd.append('sec_TipoDocumento',   TipoDocumento);
        fd.append('sec_telefono',        tel);
        fd.append('sec_idIndicativo',    codPaisId);
        fd.append('sec_sexo',            sexoId);
        fd.append('sec_fechanacimiento', fechanacimiento);
      }

      try {
        var res    = await fetchConTiempo(base + 'ws/update_patient.php', { method: 'POST', body: fd });
        var result = await res.json();
        showMsg(result.message, result.error == 0);
        if (result.error == 0) {
          if (_pacientes[_activeIndex]) {
            _pacientes[_activeIndex].primerNombre    = primerNombre;
            _pacientes[_activeIndex].primerApellido  = primerApellido;
            _pacientes[_activeIndex].nombres         = (primerNombre + ' ' + segundoNombre).trim();
            _pacientes[_activeIndex].apellidos       = (primerApellido + ' ' + segundoApellido).trim();
            _pacientes[_activeIndex].documento       = documento;
            _pacientes[_activeIndex].tipodocumento   = TipoDocumento;
            _pacientes[_activeIndex].telefono        = tel;
            _pacientes[_activeIndex].indicativo      = codPaisId;
            _pacientes[_activeIndex].sexo            = sexo;
            _pacientes[_activeIndex].fechanacimiento = fechanacimiento;
            _pacientes[_activeIndex].email           = esTitular ? newEmail : (newEmail || _pacientes[_activeIndex].email);
          }

          syncPaciente(_pacientes[_activeIndex]);
          sessionStorage.setItem('vlc_active_index', String(_activeIndex));
          setTimeout(function () { window.location.href = window.location.pathname + '?tab=contacto'; }, 1500);
        }
      } catch (err) {
        console.error('vlc save:', err);
        showMsg('Error al guardar los datos', false);
      } finally {
        loading('hide');
        btnSave.disabled = false;
        document.getElementById('btn-save-text').textContent = 'Guardar cambios';
      }
    });
  }

  window.vlcLogout = function () {
    /* Cuentas nuevas: el cierre de sesión es una página de Shopify, se navega a ella */
    if (window.VTL_CUENTAS_NUEVAS && window.VTL_LOGOUT_URL) { window.location.href = window.VTL_LOGOUT_URL; return; }
    fetch(window.VTL_LOGOUT_URL || '/account/logout', { method: 'GET', credentials: 'include' })
      .finally(function () { window.location.href = window.location.pathname + '?tab=contacto'; });
  };

})();